module.exports = __webpack_public_path__ + "img/lv0.09cb5c17.png";